module.exports = __webpack_public_path__ + "img/equinix-black.74a27b4d.svg";